/*
These include 'minor' currency units for applicable currencies.
For example:
- 1 billion _pennies_ not dollars
- 1 billion Yen (they don't have minor units)
*/
export function calculateCurrencyDisplay(event: any): number {
  let str: string = event.target.value;
  str = str.replace(/[^\d]/, '');
  let num: number = parseInt(str, 10);
  if (event.key === 'Backspace' && (num === 0 || isNaN(num))) {
    num = null;
  } else {
    if (isNaN(num)) {
      num = 0;
    }
    if (num > maxValue) {
      num = maxValue;
    }
    if (num < minValue) {
      num = minValue;
    }
  }
  return num;
}
export const maxValue = 1000000000;
export const minValue = -1000000000;
export { galaxyToApi, apiToGalaxy } from './renderers/currency';
